import baseAPI from "../app/baseAPI";

export const ProductReducer = baseAPI.injectEndpoints({
  endpoints(builder) {
    return {
      fetchProductDetails: builder.query({
        query() {
          return {
            url: `https://jobmanagement-497524552274.us-central1.run.app/jobs`,
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),
    };
  },
});
export const {
  useFetchProductDetailsQuery

} = ProductReducer;
